import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, Transition as _Transition, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a6c37d60"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "user__info"
}
const _hoisted_2 = {
  key: 0,
  class: "full__name"
}

import {h, onMounted, ref, Transition} from "vue";
import CustomHeader from "@/components/CustomHeader.vue";
import Icon from "@/components/Icon.vue";
import {MenuOption, NAvatar, NMenu} from "naive-ui";
import {RouterLink} from "vue-router";
import {useEntidadeStore} from "@/stores/entidade";
import {useUserStore} from "@/stores/user";
import {capitalize} from "@/utils/utilMethods";
import KeyCloakService from "@/security/KeycloakService";
import {useRemessasStore} from "@/stores/remessa"



export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardLayout',
  setup(__props) {

const entidadeStore = useEntidadeStore();
const remessaStore = useRemessasStore();
const userStore = useUserStore();
const username = ref<string>('');
const loading = ref(true);
const collapsed = ref(true);
const showName = ref(false);
const anoAtual = ref(new Date().getFullYear());

const sair = () => {
  userStore.deleteUser();
  entidadeStore.deleteEntidadeSelecionada();
  remessaStore.deleteRemessas();
  remessaStore.deleteRemessaSelecionada();
  KeyCloakService.CallLogOut()
}

onMounted(() => {
  console.log("mounted");
  setTimeout(() => {
    username.value = userStore.getUser()?.given_name!;
    loading.value = false;
  }, 100);
});

const menuOptions: MenuOption[] = [
  {
    label: () =>
      h(
        RouterLink,
        {
          to: "/home",
        },
        "Início"
      ),
    key: "inicio",
    icon: () => h(Icon, { nameIcon: "home-outline" }),
  },
  {
    label: () =>
      h(
        RouterLink,
        {
          to: "/remessas",
        },
        "Remessas"
      ),
    key: "remessas",
    icon: () => h(Icon, { nameIcon: "file-outline" }),
  },
  {
    label: () =>
      h(
        RouterLink,
        {
          to: "/",
        },
        "Entidades"
      ),
    key: "entidades",
    icon: () => h(h(Icon, { nameIcon: "restore" })),
  },
  {
    label: "Sair",
    key: "sair",
    icon: () => h(Icon, { nameIcon: "logout-variant" }),
  },
];

return (_ctx: any,_cache: any) => {
  const _component_n_skeleton = _resolveComponent("n-skeleton")!
  const _component_n_layout_sider = _resolveComponent("n-layout-sider")!
  const _component_n_layout = _resolveComponent("n-layout")!
  const _component_n_layout_footer = _resolveComponent("n-layout-footer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_n_layout, {
      "has-sider": "",
      position: "absolute"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_n_layout_sider, {
          "collapse-mode": "width",
          "collapsed-width": 64,
          width: 240,
          collapsed: collapsed.value,
          onmouseover: 
            () => {
                collapsed.value = false;
                showName.value = true;
            }
            ,
          onmouseout: 
            () => {
                collapsed.value = true;
                showName.value = false;
            }
            
        }, {
          default: _withCtx(() => [
            (loading.value)
              ? (_openBlock(), _createBlock(_component_n_skeleton, {
                  key: 0,
                  text: "",
                  repeat: 2
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_unref(NAvatar), {
                    round: "",
                    size: 40,
                    color: "rgba(0, 114, 119, 1)"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(username.value.substring(0, 1)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                      (showName.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(capitalize)(username.value)), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])),
            _createVNode(_unref(NMenu), {
              class: "menu",
              collapsed: collapsed.value,
              "collapsed-width": 64,
              "collapsed-icon-size": 22,
              options: 
                menuOptions.map((option) => {
                    if (option.key === 'sair') {
                    option.onClick = () => sair();
                    }
                    return option;
                })
            
            }, null, 8, ["collapsed", "options"])
          ]),
          _: 1
        }, 8, ["collapsed", "onmouseover", "onmouseout"]),
        _createVNode(_component_n_layout, null, {
          default: _withCtx(() => [
            _createVNode(_component_n_layout, {
              "native-scrollbar": false,
              content: ""
            }, {
              default: _withCtx(() => [
                _createVNode(CustomHeader),
                _renderSlot(_ctx.$slots, "default")
              ]),
              _: 3
            })
          ]),
          _: 3
        }),
        _createVNode(_component_n_layout_footer, {
          position: "absolute",
          class: "copyright center"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" ©Tribunal de Contas do Estado do Maranhão - " + _toDisplayString(anoAtual.value), 1)
          ]),
          _: 1
        })
      ]),
      _: 3
    })
  ]))
}
}

})